import { Box, Typography } from "@mui/material";
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { BASE_COLORS } from "../../utils/colors";

const ReusableBarChart = ({ title, data, xAxisKey }) => {
  if (!data || data.length === 0)
    return <Typography>لا يوجد بيانات</Typography>;

  const viewTypes = Object.keys(data[0]).filter((key) => key !== xAxisKey);

  return (
    <Box
      sx={{
        background: "white",
        width: {xs:"100%", sm: "calc(70% - 20px)"},
        padding: { xs: "16px", sm: "24px" },
        display: "flex",
        flexDirection: "column",
        textAlign: "left",
        gap: "16px",
        borderRadius: "16px",
        boxSizing: "border-box",
      }}
    >
      <Box sx={{ width: "100%", height: { xs: 240, sm: 300 } }}>
        <Typography variant="h5" fontWeight={600} >
          {title}
        </Typography>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{ top: 10, right: 10, left: 0, bottom: 5 }}
          >
            <XAxis
              dataKey={xAxisKey}
              tick={{ fontSize: 12 }}
              padding={{ left: 4, right: 4 }}
            />
            <YAxis orientation="right" tick={{ fontSize: 12 }} />
            <Tooltip />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            {viewTypes.map((vt, index) => (
              <Bar
                key={vt}
                dataKey={vt}
                fill={BASE_COLORS[index % BASE_COLORS.length]}
                barSize={viewTypes.length > 1 ? 24 : 40} // dynamic size
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default ReusableBarChart;
